import { withLDProvider } from 'launchdarkly-react-client-sdk';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';

const isDevelopment = process.env.NODE_ENV === 'development';

if (isDevelopment) {
  const { worker } = require('./mocks/browser');
  worker.start();
}

const clientSideID = process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID;

let Root = App;

// inject Dynatrace script if defined
const dynatraceScriptUrl = process.env.REACT_APP_DYNATRACE_SCRIPT_TAG_URL;
if (dynatraceScriptUrl && dynatraceScriptUrl !== 'undefined') {
  const script = document.createElement('script');
  script.src = dynatraceScriptUrl;
  script.crossOrigin = 'anonymous';
  script.async = true;
  document.head.appendChild(script);
}

// Omitted the context option since there is no useable context
if (clientSideID) {
  console.log('LaunchDarkly Client ID found!');
  Root = withLDProvider({
    clientSideID,
    timeout: 5,
    reactOptions: {
      useCamelCaseFlagKeys: true,
    },
  })(App);
} else {
  console.log(
    'LaunchDarkly Client ID not found. Set REACT_APP_LAUNCHDARKLY_CLIENT_ID environment variable.',
  );
}

ReactDOM.render(<Root />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

if (!isDevelopment) {
  serviceWorker.unregister();
}
